var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto my-5",attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Directory")]),_c('v-card-text',[_vm._v(" Coming soon... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }